export default "__VITE_ASSET__DlSmscLP__"